module.exports = __webpack_public_path__ + "media/sphere_texture.d22998b0.webm";